// Expects the CTA JSON that is provided to us via an XSL file (see offer-details)
// it comes in as an array of slightly odd objs (built from Tools DCR toJson)
// so lets just clean each of those objs up a bit

// ultimately, we xfrom each cta to look like:
// { class:
// label:
// destination:
// href:
// km: }

/*
From CTA-Glossryary:
<option label="Request a Quote" value="Request a Quote|request-a-quote" />
<option label="Schedule a Test Drive" value="Schedule a Test Drive|schedule-a-test-drive" />
<option label="Contact Dealer" value="Contact Dealer|contact-dealer" />
<option label="Explore Offers" value="Explore Offers|offers" />
<option label="Search New Inventory" value="Search New Inventory|inventory" />
<option label="Estimate Payment" value="Estimate Payment|payment-calculator" />
<option label="Apply for Credit" value="Apply for Credit|apply-for-credit" />
<option label="Get Trade-in Estimate" value="Get Trade-in Estimate|trade-in-value" />
<option label="Build &amp; Price" value="Build Deal|deal-builder" />
<option label="Toyota Safety Sense" value="Toyota Safety Sense|tss" />
<option label="Visit Dealer Website" value="Visit Dealer Website|dealer-site" />
<option label="View Comparisons" value="View Comparisons|compare-vehicles" />
<option label="Find Hydrogen Stations" value="Find Hydrogen Stations|find-hydrogen-stations" />
some also have live-chat
*/

import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';

// I'm pretty sure ALL CTAs are datalayer links
var __classMap = {
  red: 'btn btn-primary datalayer-link',
  grey: 'btn btn-grey datalayer-link',
  'grey-dark': 'btn btn-grey-dark datalayer-link',
};

/*
  Need to output default HREF vals for our CTAs.
  Those with same values as key are accounted for via JS, features/ctas.
  or have "better" defaults in case things fail. IE: dealer-site: dealers/
  TODO: They SHOULD have full default here though (after dropping tdaconfig prefix)
  URL values as seen in footer on prod home/, hence some differneces (path/, path/index.page)
*/

var __defaultHrefFromDestination = {
  'request-a-quote': 'request-a-quote/index.page',
  'schedule-a-test-drive': 'schedule-a-test-drive/index.page',
  'contact-dealer': 'contact-dealer/index.page',
  offers: 'offers/index.page',
  inventory: 'inventory/index.page',
  'payment-calculator': 'payment-estimator/index.page',
  'apply-for-credit': 'external_OCA',
  'trade-in-value': 'trade-in-value/',
  'deal-builder': 'deal-builder',
  tss: 'tools/toyota-safety-sense/index.page',
  'dealer-site': 'dealers/',
  'compare-vehicles': 'compare/',
  'find-hydrogen-stations': 'mirai/stations/',
  'live-chat': '#live-chat'
};

// This should cover all of the KM's, if not, add accordingly
var __ctaToKm = {
  'dealer-site': 'km-dealer-visit_site',
  'apply-for-credit': 'km-oca-clickout',
  'deal-builder': 'km-build-clickout',
  'compare-vehicles': 'km-compare-clickout',
  'live-chat': 'km-dealer-chat',
};

function __destination(url) {
  var urlArr = url.split('/');
  if (urlArr[1] === 'sites') {
    urlArr.splice(0, 3); // drop '', 'sites', 'TDA'
    urlArr.unshift('/' + tdaConfig.site.context_url);
    return urlArr.join('/');
  }
  return url;
}

export default function toolsDcrCtas(ctasArr) {
  var xFormedCtas = ctasArr.map(function (item) {
    // need to remove top level prop, whatever that may be
    // This comes from Tools DCR data. ie: could be item.CTAs, or item.CTAs-Bottom
    // so far, only in use with offer-details and vehicle-info-bottom
    var firstKey = Object.keys(item)[0];
    return item[firstKey]; // Remove that top level CTAs prop
  })
    // xform most of each CTA props
    .map(function mostProps(item) {
      var newItem = {};
      newItem._dcr = $.extend({}, item); // stash og vals

      // It's possible to save a CTA w/out a color in the Tools DCR. Default that.
      if (!item.CTAcolors) {
        newItem.class = __classMap.grey;
      } else {
        newItem.class = __classMap[item.CTAcolors];
      }

      var outArr = item.OutcomeCTAs.split('|');
      newItem.label = outArr[0] === 'Custom' ? item.CustomCTATitle : outArr[0];
      newItem.destination = outArr.slice(-1).pop();
      newItem.href = '/' + tdaConfig.site.context_url + '/' + __defaultHrefFromDestination[newItem.destination];
      newItem.target = item.CustomLinkTarget === '_blank' ? '_blank' : '_self';
      newItem.km = __ctaToKm[newItem.destination] ? __ctaToKm[newItem.destination] : '';
      return newItem;
    })

    // xform custom CTA destination
    .map(function destinationProp(item) {
      var newItem = item;
      if (item.destination === 'custom' && item._dcr.CustomCTADestination) {
        newItem.href = __destination(item._dcr.CustomCTADestination);
      }
      return newItem;
    });

  return xFormedCtas;
};
